import React from "react";
import { StarFilled } from "@ant-design/icons";

import "./trust-strip.component.styles.scss";
import { useLang } from "../../../lib/i18n";
import { useReveal } from "../../../lib/motion";

const TrustStrip: React.FC = () => {
  const { lang } = useLang();
  const isEn = lang === "en";
  const railRef = useReveal<HTMLDivElement>();
  return (
    <section
      className="lvs-trust"
      aria-label={isEn ? "Numbers and trust" : "Numeri e fiducia"}
    >
      <div className="lvs-trust__rail lvs-container lvs-reveal-group" ref={railRef}>
        <div className="lvs-trust__item">
          <span className="lvs-trust__num">
            5.0
            <StarFilled className="lvs-trust__star" />
          </span>
          <span className="lvs-trust__label">
            {isEn
              ? "verified reviews on Treatwell"
              : "recensioni verificate su Treatwell"}
          </span>
        </div>
        <span className="lvs-trust__sep" aria-hidden="true">☉</span>
        <div className="lvs-trust__item">
          <span className="lvs-trust__num">10+</span>
          <span className="lvs-trust__label">
            {isEn
              ? "years as a wellness studio in Florence"
              : "anni di studio olistico a Firenze"}
          </span>
        </div>
        <span className="lvs-trust__sep" aria-hidden="true">☾</span>
        <div className="lvs-trust__item">
          <span className="lvs-trust__num">300+</span>
          <span className="lvs-trust__label">
            {isEn
              ? "wellness rituals per year"
              : "rituali di benessere all'anno"}
          </span>
        </div>
        <span className="lvs-trust__sep" aria-hidden="true">✧</span>
        <div className="lvs-trust__item">
          <span className="lvs-trust__num">1:1</span>
          <span className="lvs-trust__label">
            {isEn
              ? "private studio · by appointment"
              : "studio privato · su appuntamento"}
          </span>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
